module.exports = __webpack_public_path__ + "img/10.aea5373d.png";